/**
 * KeywordAbilityIcon — mana-font `ms-ability-*` icon, or a generated glyph badge
 * (circle with big first letter + subscript second letter) for keywords mana-font lacks.
 * Always renders a fixed `size`×`size` box so it aligns like the SVG role icons.
 */
import type { ReactElement } from 'react';

import clsx from 'clsx';

import type { KeywordIconDef } from '@/lib/keywordIcons';

export interface KeywordAbilityIconProps {
  def: Pick<KeywordIconDef, 'icon' | 'glyph'>;
  color?: string;
  /** Box size in px (default: 16, matching role icons) */
  size?: number;
  title?: string;
  className?: string;
}

export default function KeywordAbilityIcon({ def, color, size = 16, title, className }: KeywordAbilityIconProps): ReactElement {
  return (
    <span
      className={clsx('flex shrink-0 items-center justify-center leading-none', className)}
      style={{ color, width: size, height: size, fontSize: size }}
      title={title}
      aria-hidden="true"
    >
      {def.icon ? (
        <i className={'ms ms-ability-' + def.icon} style={{ lineHeight: 1 }} />
      ) : (
        <span
          className="inline-flex size-full items-center justify-center rounded-full border-current font-bold select-none"
          style={{ borderWidth: '0.08em' }}
        >
          <span style={{ fontSize: '0.6em' }}>{def.glyph.charAt(0)}</span>
          <span style={{ fontSize: '0.38em', transform: 'translateY(0.45em)' }}>{def.glyph.charAt(1)}</span>
        </span>
      )}
    </span>
  );
}
